export default __webpack_public_path__ + "static/media/eth-black.3d3ab60a.svg";